/**
 * External dependencies
 */
import React, { useState } from "react";
import { Box, Stack, Text } from "@towersystems/towersystems-design-system";
import { connect } from "react-redux";
import { map, filter, lowerCase } from "lodash";

/**
 * Internal dependencies
 */
import { SidebarOverlay } from "modules/report-builder/layout";
import { getCubeDimensions } from "state/graph-cube/selectors";
import Button from "components/button";
import { getBuilderReportId } from "state/ui/report-builder/selectors";
import { getEditedReport } from "state/reports/selectors";
import { editReport } from "state/reports/actions";
import Search from "components/search";

const DimensionsOverlay = ({
  goBack,
  dimensions,
  selectableDimensions,
  reportId,
  ...props
}) => {
  const [query, setQuery] = useState("");

  let filtered = filter(selectableDimensions, ({ shortTitle }) =>
    lowerCase(shortTitle).includes(lowerCase(query))
  );

  const addDimensionToReport = (name) => {
    props.editReport(reportId, {
      config: { dimensions: [...dimensions, name] },
    });
    goBack();
  };

  return (
    <SidebarOverlay goBack={goBack}>
      <Box padding="large" className="report-builder__sidebar-overlay-search">
        <Search
          placeholder="Find a dimension"
          onChange={(value) => setQuery(value)}
          value={query}
        />
      </Box>
      <Box padding="large">
        <Stack space="medium">
          {map(filtered, ({ shortTitle, name }) => {
            return (
              <Button
                disabled={dimensions.includes(name)}
                onClick={() => addDimensionToReport(name)}
                text
                padding="medium"
                key={name}
                fullWidth
              >
                <Text align="left">{name}</Text>
              </Button>
            );
          })}
        </Stack>
      </Box>
    </SidebarOverlay>
  );
};

export default connect(
  (state) => {
    let reportId = getBuilderReportId(state);
    let report = getEditedReport(state, reportId);
    let dimensions = (report && report.config.dimensions) || [];

    // remove any dimensions that already exist
    let selectableDimensions = getCubeDimensions(
      state,
      report && report.config.dataSet
    );

    return { selectableDimensions, dimensions, reportId };
  },
  {
    editReport,
  }
)(DimensionsOverlay);
